import * as React from 'react'

function SvgFunArrowMiniDown(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M12 15a.475.475 0 01-.353-.163l-3.5-3.889a.6.6 0 010-.785.465.465 0 01.707 0L12 13.659l3.146-3.496a.465.465 0 01.707 0 .6.6 0 010 .785l-3.5 3.89A.475.475 0 0112 15" />
    </svg>
  )
}

export default SvgFunArrowMiniDown
